import _MemoriesCardForgetAllMutation from "../__generated__/MemoriesCardForgetAllMutation.graphql";
import _MemoriesCardForgetMutation from "../__generated__/MemoriesCardForgetMutation.graphql";
import { useState } from 'react';
import { graphql, useMutation } from 'react-relay';
import type { MemoriesCardForgetAllMutation } from '../__generated__/MemoriesCardForgetAllMutation.graphql';
import type { MemoriesCardForgetMutation } from '../__generated__/MemoriesCardForgetMutation.graphql';
import { En } from '../i18n/En';
import { T } from '../i18n/RichText';
import { t } from '../i18n/t';
import { memoryLine, newestFirst } from '../profile/memories';

// `learner { id memories }` is what lets Relay replace the list in place.
const Forget = (_MemoriesCardForgetMutation.hash && _MemoriesCardForgetMutation.hash !== "73944ac59f8af9c183fd0307d66e8bb5" && console.error("The definition of 'MemoriesCardForgetMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _MemoriesCardForgetMutation);
const ForgetAll = (_MemoriesCardForgetAllMutation.hash && _MemoriesCardForgetAllMutation.hash !== "8d4282216c4bfbf77674c1376a60d654" && console.error("The definition of 'MemoriesCardForgetAllMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _MemoriesCardForgetAllMutation);
function MemoryText({
  kind,
  text
}: {
  kind: string;
  text: string;
}) {
  const {
    k,
    params
  } = memoryLine(kind, text);
  return <T k={k} params={params} parts={{
    en: s => <En>{s}</En>
  }} />;
}
type Memory = {
  id: string;
  kind: string;
  text: string;
  createdAt: string;
};

/**
 * What the kid register's tutor remembers about the child, for the parent to
 * read and remove (kid memory design §5). Every button is off while either
 * mutation is in flight, so a double tap cannot send a second delete for a
 * row the first already removed.
 */
export function MemoriesCard({
  memories
}: {
  memories: readonly Memory[];
}) {
  const [forget, forgetting] = useMutation<MemoriesCardForgetMutation>(Forget);
  const [forgetAll, forgettingAll] = useMutation<MemoriesCardForgetAllMutation>(ForgetAll);
  const [confirming, setConfirming] = useState(false);
  const [failed, setFailed] = useState(false);
  const busy = forgetting || forgettingAll;
  const handlers = {
    onError: () => setFailed(true)
  };
  return <div className="card bg-base-100 shadow-sm">
      <div className="card-body gap-3">
        <h2 className="card-title">{t('memories-title')}</h2>
        <p className="text-sm opacity-70">{t('memories-intro')}</p>
        {memories.length === 0 ? <p>{t('memories-empty')}</p> : <>
            <ul className="flex flex-col gap-2">
              {newestFirst(memories).map(m => <li key={m.id} className="flex items-center justify-between gap-3">
                  <span>
                    <MemoryText kind={m.kind} text={m.text} />
                  </span>
                  <button type="button" className="btn btn-ghost btn-sm min-h-(--hit-min)" disabled={busy} aria-label={t('memory-forget-label', {
              text: m.text
            })} onClick={() => {
              setFailed(false);
              forget({
                variables: {
                  id: m.id
                },
                ...handlers
              });
            }}>
                    {t('memory-forget')}
                  </button>
                </li>)}
            </ul>
            {confirming ? <div role="group" className="flex flex-col gap-2">
                <p>{t('memory-forget-all-confirm')}</p>
                <div className="flex gap-2">
                  <button type="button" className="btn btn-error min-h-(--hit-min)" disabled={busy} onClick={() => {
              setFailed(false);
              forgetAll({
                variables: {},
                onCompleted: () => setConfirming(false),
                ...handlers
              });
            }}>
                    {t('memory-forget-all-yes')}
                  </button>
                  <button type="button" className="btn btn-ghost min-h-(--hit-min)" disabled={busy} onClick={() => setConfirming(false)}>
                    {t('memory-forget-all-cancel')}
                  </button>
                </div>
              </div> : <button type="button" className="btn btn-outline min-h-(--hit-min) self-start" disabled={busy} onClick={() => setConfirming(true)}>
                {t('memory-forget-all')}
              </button>}
          </>}
        {failed && <p role="alert" className="text-error">
            {t('memory-failed')}
          </p>}
      </div>
    </div>;
}